import { useTranslation } from 'react-i18next'

export default function StepHeading({
  subtitleKey,
  titleKey,
}: {
  subtitleKey?: string
  titleKey: string
}) {
  const { t } = useTranslation()

  // hw-heading/hw-subheading centre their text for the paywall and loader
  // screens; question steps read left-aligned against their option rows.
  return (
    <div className="animate-fade-up space-y-1.5">
      <h1 className="hw-heading text-left!">{t(titleKey)}</h1>

      {subtitleKey && (
        <p className="hw-subheading text-left!">{t(subtitleKey)}</p>
      )}
    </div>
  )
}
